export default __webpack_public_path__ + "static/client-7-5c66b2c2f3ea28a0efd55b368dfb393f.jpg";